<template>
  <div>
    <div class="state-list">
      <span class="" :class="{ 'state-active': currentStatus === key }" @click="changeStatus(key)"
        v-for="(item, key) in status" :key="key">{{ item.name }}</span>
      <p class="c-gray fr">共 <a class="c-333">{{ TotalCount }}</a> 位</p>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="getList(true, true)" class="emp-van-pull">
      <van-list v-model="loading" :finished="finished" :immediate-check="false" @load="getList()">
        <section class="staff-box bg-white" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
          <div class="enroll-list staff-avatar flex all-c">
            <div class="ds-avatar txt-c mr10">
              <img src="../../../assets/images/common/user-photo.jpg" v-if="!item.avatarUrl" />
              <img :src="item.avatarUrl" v-else />
            </div>
            <div class="flex-1">
              <div>
                <span class="f16 f-b mr5 lb-vm">{{ item.name }}</span>
              </div>
              <p class="mt5">
                <span class="c-black mr5">在职岗位：{{ item.inServiceCount }}个</span>
              </p>
            </div>
            <div class="txt-c phone-bor fr" @click.stop="callTel(item.phoneNumber)">
              <span class="icon icon-storePhone c-green f20 lb-vm"></span>
            </div>
          </div>
          <div class="box-foot">
            <p class="c-gray f12">本月已考勤(约)：
              <span class="c-333">{{ item.WorkHours || 0 }}</span>小时，工时奖励估计约
              <span class="c-orange">{{ item.EstCommission || 0 }}</span> 元
            </p>
            <p class="c-gray f12 mt5">累计贡献收入：<span class="c-orange">{{ item.TotalAmount || 0 }}</span> 元</p>
          </div>
        </section>
      </van-list>
      <section v-if="!loading && empty === 10">
        <div class="txt-c ds-search-blank">
          <p class="pb16"><img src='../../../assets/images/common/blank.png' /></p>
          <p class="f14 c-gray">抱歉，暂无员工哦~</p>
        </div>
        <div class="txt-c mt40 pt20">
          <van-button type="default" plain round class="share-btn c-orange" @click="go('home')">
            <span class="f16">去分享岗位</span>
          </van-button>
        </div>
      </section>
    </van-pull-refresh>
  </div>
</template>

<script>
import api from '../../../api';

export default {
  data() {
    return {
      currentStatus: '0',
      empty: 0,
      list: [],
      refreshing: false,
      loading: false,
      finished: false,
      TotalCount: 0,
      Paging: { PageIndex: 1, PageSize: 20 },
      status: {
        1: { name: '求职中', value: 1 },
        2: { name: '已入职', value: 2 },
        3: { name: '已离职', value: 3 },
        0: { name: '全部', value: 0 }
      }
    };
  },
  mounted() {
    this.getList(true);
  },
  methods: {
    async getList(init = false, isRefresh = false) {
      try {
        if (init) this.Paging.PageIndex = 1;
        if (isRefresh) this.refreshing = true;
        else this.loading = true;

        const res = await api.get('/api/vpai/vleader/seeker_list', {
          params: {
            page: this.Paging.PageIndex,
            pageSize: this.Paging.PageSize,
            empStatus: this.currentStatus
          }
        });

        let list = [];
        let total = 0;
        if (res && res.code === 10000 && res.data) {
          list = res.data.workers || [];
          total = res.data.workersCount || list.length;
        }

        if (init) this.list = list;
        else this.list = [...this.list, ...list];
        this.TotalCount = total;
        this.$nextTick(() => {
          this.empty = init && total === 0 ? 10 : 0;
          this.finished = list.length < this.Paging.PageSize;
          this.Paging.PageIndex++;
          this.loading = false;
          this.refreshing = false;
        });
      } catch (e) {
        this.loading = false;
        this.refreshing = false;
        this.finished = true;
        this.$error(e.message);
      }
    },
    changeStatus(status) {
      this.currentStatus = status;
      this.getList(true);
    },
    goDetail(item) {
      this.go(`employee-detail?id=${item.seekerId}`);
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/theme.less';

.state-list {
  padding: 10px 15px;
}

.state-list span {
  padding: 4px 8px;
  border: 1px solid @borderColor;
  border-radius: 3px;
  background: @white;
  margin-right: 10px;
}

.state-list span.state-active {
  border-color: @primaryColor;
  color: @primaryColor;
}

.staff-box {
  margin: 5px 15px 10px 15px;
  border-radius: 5px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
}

.staff-avatar {
  padding: 20px;
}

.wld-avatar {
  padding: 15px 20px;
}

.staff-avatar .ds-avatar {
  width: 44px;
  height: 44px;
}

.box-foot {
  border-top: 1px dashed #d2d5d6;
  padding: 15px 20px;
}

.share-btn {
  width: 180px;
  background: transparent;
  border-color: @primaryColor;
}

.emp-van-pull {
  min-height: calc(100vh - 155px);
}
</style>
